<div
    class="hot-toast-info-icon"
    [style.--warn-primary]="theme()?.primary"
    [style.--warn-secondary]="theme()?.secondary"></div>
